import { render, staticRenderFns } from "./LottieForegroundPlayer.vue?vue&type=template&id=f0bdb990&scoped=true"
import script from "./LottieForegroundPlayer.vue?vue&type=script&lang=js"
export * from "./LottieForegroundPlayer.vue?vue&type=script&lang=js"
import style0 from "./LottieForegroundPlayer.vue?vue&type=style&index=0&id=f0bdb990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bdb990",
  null
  
)

export default component.exports